import Model from '@/Models/Model'

export default class Affiliate extends Model {
  /**
   * Resource
   *
   * @returns {string}
   */
  resource() {
    return 'affiliates'
  }
}
